export const PublicRoutes = {
  ROOT: '/',
  SLUG: '/:slug',
  SUCCESS: '/:slug/success',
  LOGIN: '/:slug/backoffice/login',
  NOTFOUND: '/not-found',
  CONTRACT: '/:slug/contract/:loginCode',
  CHECKLIST: '/:slug/checklist/:id',
  BANKACCOUNT: '/:slug/bank-account/:idContract'
}

export const PrivateRoutes = {
  HOME: '/:slug/backoffice/',
  SUPPLY: '/:slug/backoffice/solicitar-insumos',
  RECIBIDOS: '/:slug/backoffice/recibidos',
  ENCUSTODIA: '/:slug/backoffice/custodia',
  RETIRADOS: '/:slug/backoffice/retirados',
  TRADEIN: '/:slug/backoffice/trade-in/:id',
  TRADEIN_COPPEL: '/:slug/backoffice/trade-in-coppel/:id',
  PICKUP_FORM: '/:slug/backoffice/pickup-form',
  MAILING: '/:slug/admin/mailing', // solo para falabella chile
  LOADSAMSUNGDATA: '/:slug/admin/bulk-data', // solo para peru samsung
  LOADTELCELDATA: '/:slug/admin/bulk-telcel', // solo para telcel corporativo mx
  DATABANK: '/:slug/backoffice/data-bank', // solo para peru samsung
  SUBIR_PRECIOS: '/:slug/backoffice/subir-precios',
  LISTADO_TECNICOS: '/:slug/backoffice/tecnicos/',
  FORMULARIO: '/:slug/backoffice/cotizar',
  SUCCESS: '/:slug/backoffice/cotizar/success',
  DASHBOARD: '/:slug/backoffice/dashboard',
  LOGISTIC_BOX: '/:slug/backoffice/logistic-box',
  CONTRIBUTIONS: '/:slug/admin/incentivos/listado',
  CONTRIBUTION: '/:slug/admin/incentivo/:id',
  DEVICE_REQUESTS: '/:slug/backoffice/dispositivos-solicitados'
}

// Correos autorizados a ver el módulo de Logística de cajas.
// (Legado · el acceso ahora se controla por rol, ver LOGISTIC_BOX_ROLES.)

export const LOGISTIC_BOX_ALLOWED_EMAILS = [
  'gtolentino@reuse.cl',
  'mvega@reuse.cl',
  'pszagal@falabella.cl',
  'rarteaga@reuse.cl',
  'ggatica@falabella.cl',
  'fbernales@reuse.cl'
]

// Roles que pueden ver "Logística de cajas" en global (app de las tiendas):
// admin del seller + jefe de tienda. El admin de Reuse usa la app de arrivals.
export const LOGISTIC_BOX_ROLES = [
  Number(import.meta.env.VITE_PERFIL_ADMIN),
  Number(import.meta.env.VITE_PERFIL_ADMIN_SELLER),
  Number(import.meta.env.VITE_PERFIL_JEFETIENDA),
  Number(import.meta.env.VITE_TI_JEFETIENDA_SELLOS)
]

// Slugs donde "Logística de cajas" es visible para TODOS los usuarios logueados,
// sin filtro de rol ni de correo (liberación total del módulo para ese seller).
// Solicitado para Falabella y Ripley.
export const LOGISTIC_BOX_OPEN_SLUGS = ['falabella', 'ripley']

// Roles que ven TODAS las tiendas del seller en Logística de cajas.
// Cualquier otro rol (custodia, ejecutivo, promotor, jefe de tienda, etc.) queda
// restringido a su propia tienda (resuelta vía ti_user_store).
export const LOGISTIC_BOX_ADMIN_ROLES = [
  Number(import.meta.env.VITE_PERFIL_ADMIN),
  Number(import.meta.env.VITE_PERFIL_ADMIN_SELLER),
  Number(import.meta.env.VITE_PERFIL_TI_REGION)
].filter(n => Number.isFinite(n))

// Solo el jefe de tienda queda restringido a su propia tienda (id_store).
export const LOGISTIC_BOX_JEFE_ROLES = [
  Number(import.meta.env.VITE_PERFIL_JEFETIENDA),
  Number(import.meta.env.VITE_TI_JEFETIENDA_SELLOS)
]

// Roles que pueden ver "Dispositivos solicitados": los dispositivos que los
// clientes/ejecutivos pidieron incorporar al cotizador. Solo perfiles de jefatura.
export const DEVICE_REQUESTS_ROLES = [
  Number(import.meta.env.VITE_PERFIL_ADMIN)
]
